"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Embed_svg_1 = __importDefault(require("./Embed.svg"));
/**
 * Embed icon.
 * figma link - https://www.figma.com/file/3MD0gqQEKwCAhH9RlBA41N/Q3-project-demos?type=design&node-id=919-164907&mode=design&t=eZEJeSV1DkMXfNFX-0
 */
function EmbedIcon() {
    return (0, jsx_runtime_1.jsx)(Embed_svg_1.default, {});
}
exports.EmbedIcon = EmbedIcon;
//# sourceMappingURL=EmbedIcon.js.map